import StandbyOff from "./icStandbyOff.png";
import Arrow from "./icArrow.png";
import Android from "./icAndroid.png";
import Ios from "./icIos.png";
import Video from "./icVideo.png";
import Manual from "./icManual.png";
import Clean from "./icClean.png";
import Link from "./icLink.png";
import Mobile from "./icMobile.png";

import IC_STANDBY_OFF from "./icStandbyOff.png";
import IC_ARROW from "./icArrow.png";
import IC_ANDROID from "./icAndroid.png";
import IC_IOS from "./icIos.png";
import IC_VIDEO from "./icVideo.png";
import IC_MANUAL from "./icManual.png";

export const Icon = {
 StandbyOff,
 Arrow,
 Android,
 Ios,
 Video,
 Manual,
 Clean,
 Link,
 Mobile,
};

export { IC_ARROW, IC_STANDBY_OFF, IC_ANDROID, IC_IOS, IC_VIDEO, IC_MANUAL };
